import { DocumentsImagesStoreAbstract } from '@shared/documents-images/DocumentsImagesStoreAbstract';
import { ImagesService } from '@shared/images/ImagesService';
import { Events } from '@shared/Events';

export class ImagesStore extends DocumentsImagesStoreAbstract<IImage> {
    type = 'images' as const;
    loadedEvent: string = 'images-loaded';

    fetch = ImagesService.fetchAll;

    getImageById = ImagesService.getImageById;

    downloadByIds = ImagesService.download;

    removeByUuids = uuids => {
        if (!confirm(__('js_map.images.delete_confirm'))) {
            return null;
        }
        return ImagesService.remove(this.getByUuids(uuids).map(i => i.id));
    };

    onItemsLoaded = () => {
        // load image from url var
        const vars: any = utils.getUrlVars();
        if ($.isNumeric(vars.image)) {
            Events.trigger('load-image', {
                id: vars.image,
                geographicPoint: {
                    lat: vars.lat,
                    lon: vars.lon,
                },
            });
        }
    };
}
